import React, { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
import { IoIosArrowDropright, IoMdAdd } from "react-icons/io";
import { useStores } from "../../store/index";
import PropTypes from "prop-types";
import userpic from "../../assests/userdefaultpic.jpeg";
import ApplicantLabelPopup from "../recruiter/Resume/applicant_labelPopup";
import Labels from "../recruiter/labels";
import { MdBookmark } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import PdfViewer from "./pdfViewer";
import { useObserver } from "mobx-react";
import { AiOutlineExport } from "react-icons/ai";
import ExportDataUI3 from "./export1/exportUi3";
import ExportApplicant from "./ExportApplicant";
import { FaUser } from "react-icons/fa";
import FilterPopup from "../recruiter/Components/filterPopup";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import CustomButton from "./buttons/expandingbutton";
import JobApplicantsShimmer from "../recruiter/JobApplicantsShimmer";
import JobInternshipShimmer from "../career/components/JobInternshipShimmer";
import notFoundImage from "../../assests/notfound.svg";
import { IoMdRefresh } from "react-icons/io";
import { BsCalendar4, BsCalendarDate } from "react-icons/bs";
import { getUserDetailsFromLocalStorage } from "../../services/reusable";
import { toJS } from "mobx";

const TotalApplicant2 = ({ data }) => {
  const { LabelStore, CommonStore, RecuiterStore } = useStores();
  const [selectedTags, setSelectedTags] = useState({});
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [accessTypeStatus, setAccessTypeStatus] = useState("unrestricted");
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const page = parseInt(query.get("page")) || 0;

  // Format date into DD-MM-YYYY format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Toggle tag visibility on click
  const handleTagClick = (applicantId) => {
    setSelectedTags((prev) => ({
      ...prev,
      [applicantId]: prev[applicantId] ? null : [],
    }));
  };

  // Handle color selection for tags
  const handleColorSelect = (applicantId, color) => {
    setSelectedTags((prev) => ({
      ...prev,
      [applicantId]: [...(prev[applicantId] || []), color],
    }));
  };

  //Access Type
  const accessType = async () => {
    const user = await getUserDetailsFromLocalStorage();
    console.log(user, "user");
    if (user?.access) {
      console.log(user?.access[0]?.accessType, "user?.access[0]?.accessType");
      const status =
        user?.access[0]?.accessType === "6971bb50ce17d9413a277db4"
          ? "restricted"
          : "unrestricted";
      console.log(status, "status11");
      return status;
    }
    return "unrestricted";
  };

  useEffect(() => {
    const fetchAccessType = async () => {
      const access = await accessType();
      console.log(access, "access");
      setAccessTypeStatus(access);
    };
    fetchAccessType();
  }, []);

  // Define dynamic color classes for tags
  const colorClasses = {
    blue: "bg-blue-500",
    yellow: "bg-yellow",
    green: "bg-green-500",
    red: "bg-red-500",
  };

  const handleOpenFilterPopup = () => {
    setShowFilterPopup(true);
  };

  const handleCloseFilterPopup = () => {
    setShowFilterPopup(false);
  };

  const handleApplyFilters = (appliedFilters) => {
    // setFilters(appliedFilters);
    RecuiterStore.setCompletionStatus(appliedFilters?.completionStatus);
    RecuiterStore.setInterviewType(appliedFilters?.interviewType);
    RecuiterStore.setAppliedFor(appliedFilters?.jobTitle);
    RecuiterStore.setScore(appliedFilters?.totalScore);
    RecuiterStore.setStatus(appliedFilters?.status);

    RecuiterStore.setAppliedDate(appliedFilters?.appliedDate);
    console.log(appliedFilters);

    // Reset to first page when applying filters
    navigate(`/company/talent-pool?page=0`);
    RecuiterStore.setPreviousPageForTalentPool(0);
    RecuiterStore.fetchapplicants(0);
  };

  const shouldShowResetButton = () => {
    const {
      interviewType,
      appliedDate,
      appliedFor,
      status,
      score,
      completionStatus,
    } = RecuiterStore;
    return (
      interviewType !== "" ||
      appliedDate !== "" ||
      appliedFor !== "" ||
      status !== "" ||
      score !== "" ||
      completionStatus !== ""
    );
  };

  let shimmer = {
    numRows: 5,
    rowHeight: "4rem",
    bgColor: "bg-gray-100",
    showProfilePic: true,
    page: "",
    headerTitles: [
      { name: "Profile pic", width: "5%" },
      { name: "Name", width: "15%" },
      { name: "Email ID", width: "20%" },
      { name: "Applied date", width: "15%" },
      { name: "Applied for", width: "15%" },
      { name: "Total Score", width: "10%" },
      { name: "Status", width: "10%" },
    ],
    rowBoxes: [
      {
        width: "15%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "20%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "15%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "15%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "10%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "10%",
        height: "1.2rem",
        shape: "rectangle",
      },
    ],
  };

  useEffect(() => {
    LabelStore.setApplicants(false);
  }, []);

  console.log(LabelStore.ApplicantColor, " :LabelStore.ApplicantColor");

  return useObserver(() => {
    return (
      <div className="bg-white min-h-screen">
        <FilterPopup
          show={showFilterPopup}
          onClose={handleCloseFilterPopup}
          onApply={handleApplyFilters}
        />
        {CommonStore.resume && (
          <PdfViewer
            pdfUrl={CommonStore.jobresume}
            onClose={() => CommonStore.setResume(false)}
          />
        )}
        <div className="bg-white rounded-lg p-1">
          <div className="flex items-center justify-between md:mt-8 tc1:mt-5 tc1:mb-3 md:mb-0">
            <h2 className="text-lg font-bold text-orange-500">
              Recent Applicants
            </h2>
            <div className="flex gap-3 items-center">
              <CustomButton
                text="Refresh"
                icon={IoMdRefresh}
                onClick={() => {
                  RecuiterStore.fetchapplicants(page * 10);
                }}
              />
              <div className=" flex flex-col items-center">
                <CustomButton
                  text="Filter"
                  icon={HiOutlineAdjustmentsHorizontal}
                  onClick={handleOpenFilterPopup}
                />
                <div className="relative  bottom-7 left-3">
                  {shouldShowResetButton() && !showFilterPopup && (
                    <span className="absolute top-0 right-0 w-2 h-2 bg-primary rounded-full"></span>
                  )}
                </div>
                {shouldShowResetButton() && (
                  <button
                    className="text-sm hover:underline text-primary mt-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      RecuiterStore.resetFilter();
                    }}
                  >
                    {/* Reset */}
                  </button>
                )}
              </div>

              <CustomButton
                text="Export"
                icon={AiOutlineExport}
                onClick={() => setShowExportPopup(true)}
              />
            </div>

            {/* <AiOutlineExport
              size={25}
              onClick={() => setShowExportPopup(true)}
            /> */}
          </div>

          {showExportPopup && (
            <ExportApplicant
              isModalOpen={showExportPopup}
              onClose={() => setShowExportPopup(false)}
            />
          )}

          <div className="hidden md:block lg:block mt-4 bg-white rounded-lg overflow-x-auto">
            <table className=" w-full text-center border-collapse">
              <thead>
                <tr className="bg-orange-100 w-full items-center justify-center">
                  <th className="p-4 whitespace-nowrap font-medium rounded-s-xl">
                    Profile
                  </th>
                  <th className="p-4 whitespace-nowrap font-medium">Name</th>
                  <th className="p-4 whitespace-nowrap font-medium">Mail ID</th>
                  <th className="p-4 whitespace-nowrap font-medium">
                    Applied Date
                  </th>
                  <th className="p-4 whitespace-nowrap font-medium">
                    Applied For
                  </th>
                  <th className="p-4 whitespace-nowrap font-medium">Resume</th>
                  <th className="p-4 whitespace-nowrap font-medium">
                    Total Score
                  </th>
                  <th className="p-4 whitespace-nowrap font-medium">Status</th>
                  <th className="p-4 whitespace-nowrap font-medium rounded-e-xl">
                    Tag
                  </th>
                </tr>
              </thead>

              <tbody>
                {!RecuiterStore.loader && data && data.length > 0 ? (
                  data.map((applicant, index) => (
                    <tr key={index} className="border-b">
                      <td className="p-4 flex items-center justify-center">
                        {applicant?.pic ? (
                          <img
                            src={applicant?.pic || userpic}
                            alt={`Profile of ${applicant.name}`}
                            className="w-10 h-10 items-center justify-center rounded-full"
                            onError={(e) => {
                              e.target.src = userpic;
                            }}
                            onClick={() => {
                              if (applicant?.type === "resumeSorting") {
                                CommonStore.setJobResume(applicant?.resume);
                                CommonStore.setResume(true);
                                return;
                              } else if (applicant?.type === "interview") {
                                navigate(
                                  `../applicants/${applicant?._id}?fromInterview=true&id=${applicant?.invitationFrom}`,
                                );
                                return;
                              } else if (applicant?.type === "jobPost") {
                                console.log(applicant);
                                navigate(
                                  `../job-applicants/${applicant?.jobPostId}?applicant=${applicant?.id}`,
                                );
                                return;
                              }
                              alert("MCQ coming soon");
                            }}
                          />
                        ) : (
                          <div className="w-10 flex h-10 items-center justify-center rounded-full bg-gray-200">
                            <FaUser className="text-gray-400" />
                          </div>
                        )}
                      </td>
                      <td
                        className="p-4 hover:cursor-pointer"
                        onClick={() => {
                          if (applicant?.type === "resumeSorting") {
                            CommonStore.setJobResume(applicant?.resume);
                            CommonStore.setResume(true);
                            return;
                          } else if (applicant?.type === "interview") {
                            navigate(
                              `../applicants/${applicant?._id}?fromInterview=true`,
                            );
                            return;
                          } else if (applicant?.type === "jobPost") {
                            console.log(applicant, "ssss");
                            navigate(
                              `../job-applicants/${applicant?.jobPostId}?applicant=${applicant?.id}`,
                            );
                            return;
                          }
                          alert("MCQ coming soon");
                        }}
                      >
                        {accessTypeStatus === "restricted"
                          ? applicant?.name
                            ? applicant.name.slice(0, 15) + "..."
                            : "-"
                          : applicant?.name || "-"}
                      </td>
                      <td
                        className="p-4 hover:cursor-pointer"
                        onClick={() => {
                          if (applicant?.type === "resumeSorting") {
                            CommonStore.setJobResume(applicant?.resume);
                            CommonStore.setResume(true);
                            return;
                          } else if (applicant?.type === "interview") {
                            navigate(
                              `../applicants/${applicant?._id}?fromInterview=true`,
                            );
                            return;
                          } else if (applicant?.type === "jobPost") {
                            console.log(applicant);
                            navigate(
                              `../job-applicants/${applicant?.jobPostId}?applicant=${applicant?.id}`,
                            );
                            return;
                          }
                          alert("MCQ coming soon");
                        }}
                      >
                        {accessTypeStatus === "restricted"
                          ? applicant?.email &&
                            typeof applicant.email === "string" &&
                            applicant.email.includes("@")
                            ? applicant.email.slice(0, 3) +
                              "..." +
                              "@" +
                              (applicant.email.split("@")[1] || "")
                            : "Restricted"
                          : applicant?.email || applicant?.mail || "-"}
                        <span>
                          {/* {applicant?.email ? `${applicant?.mail}%` : "-"} */}
                        </span>
                      </td>
                      <td className="p-4">{formatDate(applicant.createdAt)}</td>
                      <td className="p-4">
                        {applicant?.title ||
                          (applicant?.type === "interview"
                            ? "Interview Applicants"
                            : applicant?.type === "jobPost"
                              ? "Job Applicants"
                              : applicant?.type === "mocktest"
                                ? "MCQ's Applicants"
                                : applicant?.type === "resumeSorting"
                                  ? "All Applicants"
                                  : applicant?.type)}
                      </td>
                      <td className="p-4">
                        <button
                          className={`text-primary hover:underline ${accessTypeStatus === "restricted" ? "cursor-not-allowed" : ""}`}
                          onClick={() => {
                            if (accessTypeStatus === "restricted") {
                              return;
                            }
                            CommonStore.setJobResume(applicant?.resume);
                            CommonStore.setResume(true);
                          }}
                          disabled={accessTypeStatus === "restricted"}
                        >
                          View Resume
                        </button>
                      </td>
                      <td className="p-4">
                        <span
                          style={{
                            color: applicant?.score >= 70 ? "green" : "red",
                          }}
                        >
                          {applicant?.score ? `${applicant?.score}%` : "-"}
                        </span>
                      </td>
                      <td className="p-4">
                        <span
                          className={` py-1 rounded-md text-white text-sm whitespace-nowrap ${
                            applicant.status === 3
                              ? "bg-green-500"
                              : applicant.status === 1
                                ? "bg-blue-500"
                                : applicant.status === 2
                                  ? "bg-red-500"
                                  : applicant.status === 0
                                    ? "bg-yellow"
                                    : applicant.status === 4
                                      ? "bg-red-500"
                                      : "bg-yellow"
                          }`}
                          style={{
                            width: "85px",
                            display: "inline-block",
                            textAlign: "center",
                          }}
                        >
                          {applicant.status === 3
                            ? "Hired"
                            : applicant.status === 1
                              ? "Shortlisted"
                              : applicant.status === 2
                                ? "Rejected"
                                : applicant.status === 4
                                  ? "Proxy"
                                  : "On Hold"}
                        </span>
                      </td>
                      <td className="p-4 pr-[15px]">
                        <div className="flex items-center justify-center">
                          {selectedTags[applicant._id] ? (
                            <div className="flex space-x-2">
                              {["blue", "yellow", "green"].map((color) => (
                                <div
                                  key={color}
                                  className={`h-5 w-5 rounded-full ${colorClasses[color]} cursor-pointer ml-[-8px]`}
                                  onClick={() =>
                                    handleColorSelect(applicant._id, color)
                                  }
                                />
                              ))}
                            </div>
                          ) : (
                            addToLabelOld(applicant)
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    {/* <td
                      colSpan="8"
                      className="p-52  text-center text-3xl font-bold text-primary"
                    >
                      No data found
                    </td> */}
                  </tr>
                )}
              </tbody>
            </table>
            {RecuiterStore.loader &&
              Array.from({ length: 5 }).map((_, index) => (
                <div className="mt-5 space-y-4">
                  {Array.from({ length: shimmer.numRows }).map((_, index) => (
                    <div
                      key={index}
                      className={`${shimmer.bgColor} flex items-center rounded-lg py-3 px-5 shadow-md animate-pulse`}
                      style={{ height: shimmer.rowHeight }}
                    >
                      {/* {shimmer.showProfilePic && page !== "resumescore" && ( */}
                      <div
                        className="rounded-full bg-gray-300 animate-pulse"
                        style={{ width: "3rem", height: "3rem" }}
                      ></div>
                      {/* )} */}

                      <div className={`flex-1 ml-4 flex w-full justify-around`}>
                        {shimmer.rowBoxes.map((rowBox, idx) => (
                          <div
                            key={idx}
                            className={`bg-gray-300 ${
                              rowBox.shape === "rectangle"
                                ? "rounded-md"
                                : "rounded-full"
                            } mx-2 animate-pulse`}
                            style={{
                              width: rowBox.width,
                              height: rowBox.height,
                            }}
                          ></div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
          </div>
          {!RecuiterStore.loader && data && data.length > 0
            ? data.map((applicant, index) => (
                <div
                  key={index}
                  className="md:hidden lg:hidden bg-white p-4 mb-3 h-[15%] flex-wrap rounded-lg custom-Shadow flex flex-col gap-0"
                >
                  <div className="flex flex-row w-full text-xs justify-between items-center">
                    <div className="flex items-center gap-5">
                      <h1
                        className={`md:hidden lg:hidden py-3 w-[20%] ${
                          !data ? "animate-pulse" : ""
                        }`}
                      >
                        {data ? data.title : "Loading..."}
                        {applicant?.userId?.pic ? (
                          <img
                            src={applicant.userId?.pic || userpic}
                            alt={`Profile of ${applicant.userId?.name}`}
                            className="w-10 h-10 items-center justify-center rounded-full"
                            onError={(e) => {
                              e.target.src = userpic;
                            }}
                            onClick={() => {
                              if (applicant?.type === "resumeSorting") {
                                CommonStore.setJobResume(applicant?.resume);
                                CommonStore.setResume(true);
                                return;
                              } else if (applicant?.type === "interview") {
                                navigate(
                                  `../applicants/${applicant?._id}?fromInterview=true&id=${applicant?.invitationFrom}`,
                                );
                                return;
                              } else if (applicant?.type === "jobPost") {
                                console.log(applicant);
                                navigate(
                                  `../job-applicants/${applicant?.jobPostId}?applicant=${applicant?.id}`,
                                );
                                return;
                              }
                              alert("MCQ coming soon");
                            }}
                          />
                        ) : (
                          <div className="w-12 flex h-12 mt-2  items-center justify-center rounded-full bg-gray-200">
                            <FaUser className="text-gray-400 " />
                          </div>
                        )}
                      </h1>
                      <div className="w-32 truncate mt-2">
                        <h1
                          className=" hover:cursor-pointer text-primary "
                          onClick={() => {
                            if (applicant?.type === "resumeSorting") {
                              CommonStore.setJobResume(applicant?.resume);
                              CommonStore.setResume(true);
                              return;
                            } else if (applicant?.type === "interview") {
                              navigate(
                                `../applicants/${applicant?._id}?fromInterview=true`,
                              );
                              return;
                            } else if (applicant?.type === "jobPost") {
                              console.log(applicant, "ssss");
                              navigate(
                                `../job-applicants/${applicant?.jobPostId}?applicant=${applicant?.id}`,
                              );
                              return;
                            }
                            alert("MCQ coming soon");
                          }}
                        >
                          {applicant?.name || "-"}
                        </h1>{" "}
                        <h1
                          className=" hover:cursor-pointer "
                          onClick={() => {
                            if (applicant?.type === "resumeSorting") {
                              CommonStore.setJobResume(applicant?.resume);
                              CommonStore.setResume(true);
                              return;
                            } else if (applicant?.type === "interview") {
                              navigate(
                                `../applicants/${applicant?._id}?fromInterview=true`,
                              );
                              return;
                            } else if (applicant?.type === "jobPost") {
                              console.log(applicant);
                              navigate(
                                `../job-applicants/${applicant?.jobPostId}?applicant=${applicant?.id}`,
                              );
                              return;
                            }
                            alert("MCQ coming soon");
                          }}
                        >
                          {accessTypeStatus === "restricted"
                            ? "Restricted"
                            : applicant?.email || applicant?.mail || "-"}
                          <span>
                            {/* {applicant?.email ? `${applicant?.mail}%` : "-"} */}
                          </span>
                        </h1>
                      </div>
                      <div className="ml-4">
                        <span
                          className={`py-2 rounded-md text-white text-[10px] whitespace-nowrap ${
                            applicant.status === 3
                              ? "bg-green-500"
                              : applicant.status === 1
                                ? "bg-blue-500"
                                : applicant.status === 2
                                  ? "bg-red-500"
                                  : applicant.status === 0
                                    ? "bg-yellow"
                                    : "bg-yellow"
                          }`}
                          style={{
                            width: "65px",
                            display: "inline-block",
                            textAlign: "center",
                          }}
                        >
                          {applicant.status === 3
                            ? "Hired"
                            : applicant.status === 1
                              ? "Shortlisted"
                              : applicant.status === 2
                                ? "Rejected"
                                : "On Hold"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-between text-xs gap-4 whitespace-nowrap">
                    <div className="">
                      <span className="text-slate-500 mr-1">Applied for :</span>
                      {applicant?.title || applicant?.type}
                    </div>

                    <div className=" flex">
                      <span className="text-slate-500 whitespace-nowrap flex items-center mr-1">
                        <BsCalendar4 />
                        <span className="ml-1">:</span>
                      </span>
                      {formatDate(applicant.createdAt)}
                    </div>
                  </div>
                  <div className="flex justify-between ">
                    <div className="p-4">
                      <span
                        style={{
                          color: applicant?.score >= 70 ? "green" : "red",
                        }}
                      >
                        {applicant?.score ? (
                          <div className="">
                            <span>{applicant?.score}%</span>
                            <br />
                            Overall Score
                          </div>
                        ) : (
                          "-"
                        )}
                      </span>
                    </div>

                    <div className="px-4 pt-4 ">
                      {selectedTags[applicant._id] ? (
                        <div className="flex space-x-2 -mt-5">
                          {["blue", "amber", "green"].map((color) => (
                            <div
                              key={color}
                              className={`h-5 w-5 rounded-full ${colorClasses[color]} cursor-pointer ml-[-8px]`}
                              onClick={() =>
                                handleColorSelect(applicant._id, color)
                              }
                            />
                          ))}
                        </div>
                      ) : (
                        addToLabelOld(applicant)
                      )}
                    </div>
                  </div>
                </div>
              ))
            : !RecuiterStore.loader && (
                <div className="flex flex-col items-center justify-center py-10 px-4">
                  <h1 className="text-center text-xl sm:text-3xl font-bold text-primary">
                    <img
                      src={notFoundImage}
                      alt="not found"
                      className="w-40 sm:w-80 md:w-[600px] lg:w-[400px] mx-auto"
                    />
                    <p className="mt-4">No data found</p>
                  </h1>
                </div>
              )}
          <div className="md:hidden block">
            {RecuiterStore.loader && <JobInternshipShimmer />}
          </div>
        </div>
        <ApplicantLabelPopup />
      </div>
    );
  });

  function addToLabelOld(applicant) {
    return (
      <div
        className="flex items-center justify-center cursor-pointer"
        onClick={() => {
          console.log(LabelStore.ApplicantId);
          if (
            applicant?.title === "resumeSorting" ||
            applicant?.type === "resumeSorting"
          ) {
            LabelStore.setApplicantId(applicant?._id);
            LabelStore.setsection("resumeSorting");
          } else {
            LabelStore.setApplicantId(applicant?.id);
            LabelStore.setsection(applicant?.type);
          }
          LabelStore.setApplicantLabelArray(applicant.labels);
          console.log(LabelStore.Applicants);
          LabelStore.setApplicants(true);
        }}
      >
        {applicant?.labels && applicant?.labels[0] ? (
          <MdBookmark className="mx-auto text-2xl text-primary" />
        ) : (
          <MdBookmark className="mx-auto text-2xl text-gray-500" />
        )}
      </div>
    );
  }
};

// Prop validation for data prop
TotalApplicant2.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      userId: PropTypes.shape({
        name: PropTypes.string,
        mail: PropTypes.string,
        pic: PropTypes.string,
      }),
      createdAt: PropTypes.string,
      jobPostId: PropTypes.shape({
        jobTitle: PropTypes.string,
      }),
      averageScore: PropTypes.number,
      status: PropTypes.string,
    }),
  ).isRequired,
};

export default TotalApplicant2;
